var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('alpha-calendar-cancel-meeting-dialog',{attrs:{"eventid":_vm.eventId,"assignment-id":_vm.assignmentId},on:{"close":function($event){return _vm.goBack(_vm.assignmentId)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }